import { writable } from 'svelte/store';
function createActiveDropdownStore() {
    const { subscribe, update } = writable({
        id: null,
        subcategoryId: null,
        contentHeight: 0,
        showSlideInAnimation: true,
    });
    function open(id) {
        update((state) => ({
            ...state,
            id,
            subcategoryId: null,
            // only show slide in animation if the dropdown was closed,
            // show fade in/out animation when hover between categories
            showSlideInAnimation: state.id === null,
        }));
    }
    function openSubcategory(subcategoryId) {
        update((state) => ({
            ...state,
            subcategoryId,
            showSlideInAnimation: false,
        }));
    }
    function close() {
        update((state) => ({ ...state, id: null, subcategoryId: null, showSlideInAnimation: true }));
        updateContentHeight(0);
    }
    function closeSubcategory() {
        update((state) => ({ ...state, subcategoryId: null }));
    }
    function updateContentHeight(contentHeight) {
        update((state) => ({ ...state, contentHeight }));
    }
    return {
        subscribe,
        open,
        openSubcategory,
        close,
        closeSubcategory,
        updateContentHeight,
    };
}
export const activeDropdownStore = createActiveDropdownStore();
